import { matchPath, Redirect, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import {
    IonApp,
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonIcon,
    IonLabel,
    IonLoading,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { refresh } from "ionicons/icons";
import Login from "../pages/login/login";
import { useDispatch, useSelector } from "react-redux";
import { RootState, getLastLoggedInEmail } from "../redux/store";
import "./tabbarStyle.css";
import CreateMatchPage from "../pages/match/createMatch";
import { getProfile } from "../services/profileService";
import { LoginSession } from "../redux/models/loginSession";
import { addUserProfile } from "../redux/actions/addUserProfile";
import { setCurrentUser } from "../redux/actions/currentUser";
import { SubscriptionService } from "../services/subscriptionService";
import FixturesSegments from "../pages/tabs/fixturesSegments/fixturesSegments";
import React, { FC, useEffect, useState } from "react";
import { PageViewAnalytics } from "../services/analytics/pageViewAnalytics";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { routes, sentryDsn } from "./constants";
import Settings from "../pages/tabs/more/settings/settings";
import { Profile } from "../pages/tabs/more/profile";
import Results from "../pages/tabs/results";
import Trends from "../pages/tabs/trends";
import More from "../pages/tabs/more";
import { InAppPurchaseStoreProvider } from "../components/InAppPurchaseStore";
import { AppUpdateComponent } from "../components";
import { Support } from "../pages/tabs/more/support";
import { ContactUs } from "../pages/tabs/more/contactUs";
import { MisconductCodes } from "../pages/tabs/more/settings/misconduct";
import { EditCustomMisconduct } from "../pages/tabs/more/settings/editCustomMisconduct";
import { ManageTemplates } from "../pages/tabs/more/settings/templates";
import { Template } from "../pages/tabs/more/settings/template";
import ForgotPassword from "../pages/password/forgotPassword";
import RegisterStepTwo from "../pages/register/registerStepTwo";
import Register from "../pages/register/register";
import ForgotPasswordComplete from "../pages/password/forgotPasswordComplete";
import { EditEvent } from "../pages/tabs/fixturesSegments/editEvent";
import { QuickResultForm } from "../pages/addResult/addResult";
import { useTranslation } from "react-i18next";
import { WatchDebug } from "../pages/tabs/more/watchDebug";
import Watches from "../pages/tabs/more/settings/watches";
import PairWatch from "../pages/tabs/more/settings/pairWatch";
import { isAndroid, isIos } from "../services/platformDetection";
import AddResultDetailsForm from "../pages/addResult/AddResultDetailsForm";
import * as rtlDetect from "rtl-detect";
import { mpDisable, mpInit } from "../services/analytics/mixpanelService";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import { checkAuthSession } from "../services/sessionRefresh";
import { getCurrentVersionQuickly } from "../components/hooks/appVersionHooks";
import { Subscriptions } from "../pages/tabs/more/subscriptions";
import { AppStateManagement } from "../components/AppStateManagement";
import { MockWatchMessaging } from "../pages/debug/MockWatchMessaging";
import DeveloperTools from "../pages/debug/DeveloperTools";
import PouchDebug from "../pages/debug/PouchDebug";
import PouchDebugMatch from "../pages/debug/PouchDebugMatch";
import FitnessDataStatus from "../pages/debug/FitnessDataStatus";
import { TeamSheetWrapper } from "../pages/teamsheets/newTeamSheet";
import TeamPacks from "../pages/tabs/more/settings/teamPacks";
import { TeamPacksProvider } from "../components/hooks/TeamPacks";
import _ from "lodash";
import { UploadDownloadFiles } from "../pages/upload/uploadDownloadFiles";
import { AdMobService } from "../services/AdMobService";
import RegisterUpgrade from "../pages/register/registerUpgrade";
import RegisterFreeTrial from "../pages/register/registerFreeTrial";
import { CalendarSync } from "../pages/tabs/more/settings/calendarSync";
import AppUrlListener from "../components/AppUrlListener";
import { OnBoardingManager } from "../components/OnBoardingManager";
import { Notifications } from "../pages/tabs/more/notifications";
import { oneSignalSetUser } from "../services/OneSignal";
import PushConsentModal from "../modals/pushConsentModal";
import { OneSignalPushListener } from "../components/OneSignalPushListener";
import { PushToaster } from "../components/PushToaster";
import { checkIfTemplateOnDBExists } from "../services/templateService";
import { createSettingsIfDoesNotExist } from "../services/settingsService";
import { PushConsentPage } from "../pages/tabs/more/settings/pushConsentPage";
import { CancelSubscription } from "../pages/tabs/more/subscription/cancelSubscription";
import { OnboardingWatchFound } from "../pages/onBoarding/onboardingWatchFound";
import { OnBoardingSelectWatch } from "../pages/onBoarding/onBoardingSelectWatch";
import { OnBoardingPairWatch } from "../pages/onBoarding/onBoardingPairWatch";
import { OnBoardingShareLocationData } from "../pages/onBoarding/onBoardingShareLocationData";
import { OnBoardingShareHealthDataWrapper } from "../pages/onBoarding/onBoardingShareHealthData";
import { PermissionsLocationData } from "../pages/permissions/PermissionsLocationData";
import { PermissionsHealthDataWrapper } from "../pages/permissions/PermissionsHealthData";
import { OnBoardingTimerSettings } from "../pages/onBoarding/onBoardingTimerSettings";
import { OnBoardingTimerSettingsStepTwo } from "../pages/onBoarding/onBoardingTimerSettingsStepTwo";
import { OnBoardingSetupComplete } from "../pages/onBoarding/onBoardingSetupComplete";
import { OnboardingFindingYourWatch } from "../pages/onBoarding/OnboardingFindingYourWatch";
import { SelectProOrPlus } from "../pages/refsixPlus/selectProOrPlus";
import { INSTALLED_VERSION_UNKNOWN } from "../redux/models/refsixState";
import ReviewPage from "../pages/reviewPage";
import { RegisterOrLogin } from "../pages/register/registerOrLogin";
import { MigrateSystemB } from "../pages/migrateSystemB";
import ReferFriendPage from "../pages/mgm/referFriend";
import RegisterStepThree from "../pages/register/registerStepThree";
import RegisterStepFour from "../pages/register/registerStepFour";
import { GarminDebugger } from "../pages/debug/GarminDebugger";
import { OnboardingSelectGarmin } from "../pages/onBoarding/onboardingSelectGarmin";
import EditMatchDetails from "../pages/editMatch/EditMatchDetails";
import results from "../assets/images/tabs/results.svg";
import trends from "../assets/images/tabs/trends.svg";
import more from "../assets/images/tabs/more.svg";

enum TabSelected {
    results = "results",
    trends = "trends",
    more = "more",
}

const routePaths = Object.values(routes).map((path) => ({ path }));
const history = createBrowserHistory();
const textDirection = rtlDetect.getLangDir(navigator.language);

const AppInit = async () => {
    Sentry.init({
        dsn: sentryDsn,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                    history as any,
                    routePaths,
                    matchPath
                ),
            }),
        ],
        tracesSampleRate: 0, // 20% of transactions sampled
        environment: process.env.NODE_ENV,
        normalizeDepth: 10, // depth of redux state to log
    });

    Sentry.configureScope(function (scope) {
        scope.addEventProcessor((event) => {
            return new Promise(async (resolve) => {
                try {
                    const version = await getCurrentVersionQuickly();
                    const eventWithAppVersion = {
                        ...event,
                        release:
                            version === INSTALLED_VERSION_UNKNOWN
                                ? undefined
                                : version,
                    };
                    return resolve(eventWithAppVersion);
                } catch (e) {
                    console.log("Error getting app version", e);
                    return resolve(event);
                }
            });
        });
    });

    AdMobService.getInstance();
};

AppInit();

function AuthStackScreen() {
    const userStorageEmail = useSelector(
        (state: RootState) => state.user.usernameOrEmail
    );
    // Fallback to localStorage for after logout (persist:root is cleared but this is preserved)
    const lastLoggedInEmail = userStorageEmail || getLastLoggedInEmail();

    return (
        <IonApp className={textDirection}>
            <IonReactRouter history={history}>
                <AppUrlListener></AppUrlListener>
                {/* TODO - reinstate if we chose onesignal */}
                {/*<OneSignalPushListener />*/}
                <PageViewAnalytics />
                <IonRouterOutlet>
                    <Route
                        path={routes.registerOrLogin}
                        component={RegisterOrLogin}
                    />
                    <Route path={routes.register} component={Register} />
                    <Route path={routes.login} component={Login} />
                    <Route
                        path={routes.forgotPassword}
                        render={() => <ForgotPassword />}
                    />
                    <Route
                        path={routes.resetPassword}
                        component={ForgotPasswordComplete}
                    />
                    <Route
                        path={routes.mockWatchMessaging}
                        component={MockWatchMessaging}
                    />
                    <Route
                        path={routes.developerTools}
                        component={DeveloperTools}
                    />
                    <Route path={routes.pouchDebug} component={PouchDebug} />
                    <Route
                        path={routes.pouchDebugMatch}
                        component={PouchDebugMatch}
                    />
                    <Redirect
                        exact
                        to={
                            lastLoggedInEmail
                                ? routes.login
                                : routes.registerOrLogin
                        }
                        from={"/"}
                    />
                    <Redirect to={routes.login} from={routes.tabMore} />
                    {/* Catch-all: redirect any unmatched route to login */}
                    <Route
                        render={() => (
                            <Redirect
                                to={
                                    lastLoggedInEmail
                                        ? routes.login
                                        : routes.registerOrLogin
                                }
                            />
                        )}
                    />
                </IonRouterOutlet>
            </IonReactRouter>
        </IonApp>
    );
}

const resolveTabSelected = (path: string): string => {
    switch (path) {
        case routes.tabTrends:
            return TabSelected.trends;
        case routes.tabMore:
            return TabSelected.more;
        case routes.tabResults:
        default:
            return TabSelected.results; // Default to results if no match
    }
};

const TabBarScreens: FC<{}> = () => {
    const [tabSelected, setTabSelected] = useState<string>(
        resolveTabSelected(window.location.pathname)
    );

    const { t } = useTranslation();

    const loadingMatches = useSelector(
        (state: RootState) => state.matches.loading
    );

    useEffect(() => {
        // Initialise mixpanel once logged in
        mpInit();
        // See if auth session expires soon and needs updating
        checkAuthSession().catch(() => {});
        // Live updates
        CapacitorUpdater.notifyAppReady();

        // Disable mixpanel when this component gets unmounted
        return () => {
            mpDisable();
        };
    }, []);

    useEffect(() => {
        if (!loadingMatches) {
            // Creating settings for user if they don't exist
            createSettingsIfDoesNotExist();
            // Check templates
            checkIfTemplateOnDBExists();
        }
    }, [loadingMatches]);

    const renderProviderNative = (children: JSX.Element) => {
        //return children;
        if (!isIos() && !isAndroid()) return children;
        return _.reduce(
            [InAppPurchaseStoreProvider],
            (acc, C) => {
                return <C>{acc}</C>;
            },
            children
        );
    };
    const renderProvider = (children: JSX.Element) => {
        //return children;
        return _.reduce(
            [TeamPacksProvider],
            (acc, C) => {
                return <C>{acc}</C>;
            },
            children
        );
    };
    const renderAllProviders = (children: JSX.Element) => {
        return renderProviderNative(renderProvider(children));
    };

    return renderAllProviders(
        <IonApp className={textDirection}>
            <AppUpdateComponent />
            <AppStateManagement />
            {/* LoadingMatches can be undefined when the app is first booting so checking not false */}
            <IonLoading
                isOpen={loadingMatches !== false}
                htmlAttributes={{ "data-testid": "loadingMatchesSpinner" }}
            ></IonLoading>
            <PushConsentModal />
            <IonReactRouter history={history}>
                <OnBoardingManager />
                <AppUrlListener />
                <OneSignalPushListener />
                <PushToaster />
                <PageViewAnalytics />
                <IonRouterOutlet>
                    <Route
                        path={routes.migrateSystemB}
                        component={MigrateSystemB}
                    />
                    <Route
                        path={routes.registerStepTwo}
                        component={RegisterStepTwo}
                    />
                    <Route
                        path={routes.registerStepThree}
                        component={RegisterStepThree}
                    />
                    <Route
                        path={routes.registerStepFour}
                        component={RegisterStepFour}
                    />
                    <Route
                        path={routes.registerUpgrade}
                        component={RegisterUpgrade}
                    />
                    <Route
                        path={routes.registerFreeTrial}
                        component={RegisterFreeTrial}
                    />
                    <Route
                        path={routes.onboardingGettingStarted}
                        component={OnboardingFindingYourWatch}
                    />
                    <Route
                        path={routes.onboardingFoundWatch + "/:watchPlatform"}
                        component={OnboardingWatchFound}
                    />
                    <Route
                        path={routes.onboardingNoWatchFound}
                        component={OnBoardingSelectWatch}
                    />
                    <Route
                        path={routes.onboardingPairWatch + "/:watchPlatform"}
                        component={OnBoardingPairWatch}
                    />
                    <Route
                        path={routes.onBoardingShareLocationData}
                        component={OnBoardingShareLocationData}
                    />
                    <Route
                        path={routes.onBoardingShareHealthData}
                        component={OnBoardingShareHealthDataWrapper}
                    />
                    <Route
                        path={routes.permissionsLocationData}
                        component={PermissionsLocationData}
                    />
                    <Route
                        path={routes.permissionsHealthData}
                        component={PermissionsHealthDataWrapper}
                    />
                    <Route
                        path={routes.onBoardingTimerSettings}
                        component={OnBoardingTimerSettings}
                    />
                    <Route
                        path={routes.onBoardingSetupComplete}
                        component={OnBoardingSetupComplete}
                    />
                    <Route
                        path={routes.onBoardingTimerSettingsStepTwo}
                        component={OnBoardingTimerSettingsStepTwo}
                    />
                    <Route
                        path={routes.onboardingSelectGarmin}
                        component={OnboardingSelectGarmin}
                    />
                    <Route
                        path={routes.upgrade + "/:upgradeType"}
                        component={SelectProOrPlus}
                    />
                    <Redirect
                        exact
                        to={routes.upgrade + "/pro"}
                        from={routes.upgrade}
                    />
                    <Route
                        path={routes.match + "/:id/:page"}
                        component={FixturesSegments}
                    />
                    <Redirect
                        from="/overview/:id"
                        to={routes.match + "/:id/overview"}
                    />
                    <Route
                        path={routes.createMatch}
                        component={CreateMatchPage}
                    />
                    <Route
                        path={routes.createMatch + "/:id"}
                        component={CreateMatchPage}
                    />
                    <Route path={routes.moreProfile} component={Profile} />
                    <Route
                        path={routes.moreNotifications}
                        component={Notifications}
                    />
                    <Route
                        path={routes.moreSubscriptions}
                        component={Subscriptions}
                    />
                    <Route
                        path={routes.subscriptionCancel + "/:provider"}
                        component={CancelSubscription}
                    />
                    <Route path={routes.moreSettings} component={Settings} />
                    <Route
                        path={routes.moreWatchDebug}
                        component={WatchDebug}
                    />

                    <Route
                        path={routes.garminDebugger}
                        component={GarminDebugger}
                    />
                    <Route
                        path={routes.mockWatchMessaging}
                        component={MockWatchMessaging}
                    />
                    <Route
                        path={routes.developerTools}
                        component={DeveloperTools}
                    />
                    <Route path={routes.pouchDebug} component={PouchDebug} />
                    <Route
                        path={routes.pouchDebugMatch}
                        component={PouchDebugMatch}
                    />
                    <Route
                        path={routes.fitnessDataStatus}
                        component={FitnessDataStatus}
                    />
                    <Route path={routes.moreSupport} component={Support} />
                    <Route
                        path={routes.moreSupportContact}
                        component={ContactUs}
                    />
                    <Route
                        path={routes.moreSettingsMisconductCodes}
                        component={MisconductCodes}
                    />
                    <Route
                        path={routes.moreSettingsEditCustomMisconductCodes}
                        component={EditCustomMisconduct}
                    />
                    <Route
                        path={routes.moreSettingsTemplates}
                        component={ManageTemplates}
                    />
                    <Route
                        path={routes.moreSettingsTemplatesTemplate}
                        component={Template}
                    />
                    <Route
                        path={routes.moreSettingsTemplatesTemplate + "/:id"}
                        component={Template}
                    />
                    <Route
                        path={routes.addEditTeamSheet + "/:id/:team"}
                        component={TeamSheetWrapper}
                    />
                    <Route
                        path={routes.resultsAddEvent + "/:matchId/:eventTs?"}
                        component={EditEvent}
                    />

                    <Route
                        path={routes.addResult}
                        component={QuickResultForm}
                    />
                    <Route
                        path={routes.addMultipleMatches}
                        component={UploadDownloadFiles}
                    />
                    <Route
                        exact
                        path={routes.addResultDetail + "/:id"}
                        component={AddResultDetailsForm}
                    />
                    <Route
                        exact
                        path={routes.editMatchDetails + "/:id"}
                        component={EditMatchDetails}
                    />
                    <Route
                        exact
                        path={routes.moreSettingsManageWatches}
                        component={Watches}
                    />
                    <Route
                        exact
                        path={routes.moreSettingsManageWatchesPair}
                        component={PairWatch}
                    />
                    <Route
                        exact
                        path={routes.moreSettingsSyncCalendar}
                        component={CalendarSync}
                    />
                    <Route
                        exact
                        path={routes.moreSettingsPushConsent}
                        component={PushConsentPage}
                    />
                    <Route
                        exact
                        path={routes.teamPacks}
                        component={TeamPacks}
                    />
                    <Route exact path={routes.review} component={ReviewPage} />
                    <Redirect
                        exact
                        to={routes.tabResults}
                        from={routes.fixturesFilter}
                    />
                    <Redirect
                        exact
                        to={routes.tabResults}
                        from={routes.resultsFilters}
                    />
                    <Redirect
                        exact
                        to={routes.tabTrends + "/matches"}
                        from={routes.trendsFilter}
                    />
                    <Route
                        path={routes.tab}
                        render={() => (
                            <div className="showTabs">
                                <IonTabs>
                                    <IonRouterOutlet>
                                        <Route
                                            exact
                                            path={routes.tabResults}
                                            component={Results}
                                        />
                                        <Route
                                            exact
                                            path={routes.tabTrends}
                                            component={Trends}
                                        />
                                        <Route
                                            exact
                                            path={routes.tabTrends + "/:page"}
                                            component={Trends}
                                        />
                                        <Route
                                            exact
                                            path={routes.tabMore}
                                            component={More}
                                        />
                                    </IonRouterOutlet>
                                    <IonTabBar slot="bottom" id="ionTabBar">
                                        <IonTabButton
                                            data-testid="tab-results"
                                            tab={TabSelected.results}
                                            href={routes.tabResults}
                                        >
                                            <IonIcon icon={results} />
                                            <IonLabel>
                                                {t("general.results")}
                                            </IonLabel>
                                        </IonTabButton>
                                        <IonTabButton
                                            data-testid="tab-trends"
                                            tab={TabSelected.trends}
                                            href={routes.tabTrends}
                                        >
                                            <IonIcon icon={trends} />
                                            <IonLabel>
                                                {t("general.trends")}
                                            </IonLabel>
                                        </IonTabButton>
                                        <IonTabButton
                                            data-testid="tab-more"
                                            tab={TabSelected.more}
                                            href={routes.tabMore}
                                        >
                                            <IonIcon icon={more} />
                                            <IonLabel>
                                                {t(
                                                    "fixture.FixtureSummaryEarnings.more"
                                                )}
                                            </IonLabel>
                                        </IonTabButton>
                                    </IonTabBar>
                                </IonTabs>
                            </div>
                        )}
                    />
                    <Route
                        path={routes.referFriend}
                        component={ReferFriendPage}
                        exact
                    />
                    <Route
                        path={routes.login}
                        render={() => <Redirect to={routes.tabResults} />}
                        exact
                    />
                    <Redirect exact to={routes.tabResults} from={"/"} />
                    <Route render={() => <Redirect to={routes.tabResults} />} />
                </IonRouterOutlet>
            </IonReactRouter>
        </IonApp>
    );
};

function Root() {
    const { t } = useTranslation();
    const userLoggedIn = useSelector((state: RootState) => state.auth.loggedIn);
    const session: LoginSession | undefined = useSelector(
        (state: RootState) => state.auth.session
    );
    const dispatch = useDispatch();

    if (userLoggedIn) {
        // TODO should we track this instance in a provider or something?
        const subService = SubscriptionService.getInstance();
        subService.initialize(userLoggedIn);
        if (session) {
            getProfile(session.user_id)
                .then(function (profile) {
                    oneSignalSetUser(session.user_id, profile.email);
                    dispatch(setCurrentUser(profile));
                    dispatch(addUserProfile(profile));
                })
                .catch((error) => console.log("Couldn't set profile", error));
        }
    }
    return (
        <Sentry.ErrorBoundary
            fallback={
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>
                            {t("general.errorTryAgain")}
                        </IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <IonButton
                            onClick={() => (window.location.pathname = "/")}
                        >
                            <IonIcon slot="icon-only" icon={refresh}></IonIcon>
                        </IonButton>
                    </IonCardContent>
                </IonCard>
            }
        >
            {userLoggedIn ? <TabBarScreens /> : <AuthStackScreen />}
        </Sentry.ErrorBoundary>
    );
}

export default Root;
